(() => {
  const SELECTORS = {
    drawer: 'cart-drawer',
    container: '[data-cart-notices]',
    inline: '[data-cart-item-error]',
    template: '#CartNoticeTemplate'
  };

  const noticeState = new Map();
  let fallbackIndex = 0;

  const getDrawer = () => document.querySelector(SELECTORS.drawer);
  const getContainer = () => getDrawer()?.querySelector(SELECTORS.container) || null;
  const getInlineNotice = (line) =>
    line ? document.querySelector(`${SELECTORS.inline}[data-line="${line}"]`) : null;

  const extractMessage = (node) => {
    const textEl = node?.querySelector('.wt-cart__error-text');
    return textEl ? textEl.innerHTML.trim() : '';
  };

  const getProductTitleFromNode = (node) => {
    const item = node?.closest('.wt-cart__item');
    if (!item) return '';
    const titleNode = item.querySelector('.wt-cart__item__name');
    return titleNode ? titleNode.textContent.trim() : '';
  };

  const buildMessageWithTitle = (message) => message;

  const hideInlineNotice = (line) => {
    const node = getInlineNotice(line);
    if (!node) return;
    node.style.display = 'none';
  };

  const clearInlineNotice = (line) => {
    const node = getInlineNotice(line);
    if (!node) return;
    const textEl = node.querySelector('.wt-cart__error-text');
    if (textEl) textEl.innerHTML = '';
    node.style.display = 'none';
  };

  const createNoticeItem = (notice) => {
    const showClose = notice.showClose !== false;
    const iconHtml = notice.iconHtml || '';

    const li = document.createElement('li');
    li.innerHTML = `
      <div class="brn-message brn-message--error wt-cart__error">
        <div class="brn-message__icon">${iconHtml}</div>
        <div class="brn-message__text">
          <p class="wt-cart__error-text"></p>
          ${showClose ? '<button type="button" class="brn-message__dismiss">Cerrar</button>' : ''}
        </div>
      </div>`;
    return li;
  };

  const renderNotices = () => {
    const container = getContainer();
    if (!container) return;

    container.innerHTML = '';
    if (!noticeState.size) {
      container.hidden = true;
      return;
    }

    const fragment = document.createDocumentFragment();
    noticeState.forEach((notice) => {
      const item = createNoticeItem(notice);
      item.classList.add('cart-notice__item', 'cart-notice__item--pending');
      if (notice.line) item.dataset.noticeLine = notice.line;
      const textEl = item.querySelector('.wt-cart__error-text');
      if (textEl) {
        textEl.innerHTML = notice.message;
        Array.from(textEl.querySelectorAll('button')).forEach(btn => textEl.after(btn));
      }
      fragment.appendChild(item);
    });

    container.hidden = false;
    container.appendChild(fragment);
    requestAnimationFrame(() => {
      container.querySelectorAll('.cart-notice__item--pending').forEach((li) => {
        li.classList.remove('cart-notice__item--pending');
        li.classList.add('cart-notice__item--visible');
      });
    });

    if (!container.dataset.noticeListener) {
      container.addEventListener('click', handleNoticeDismiss);
      container.dataset.noticeListener = 'true';
    }
  };

  const handleNoticeDismiss = (event) => {
    const dismissButton = event.target.closest('.brn-message__dismiss');
    if (!dismissButton) return;
    event.preventDefault();

    const noticeItem = dismissButton.closest('.cart-notice__item');
    if (!noticeItem) return;
    const lineId = noticeItem.dataset.noticeLine || '';
    if (lineId) {
      noticeState.delete(lineId);
      clearInlineNotice(lineId);
    }

    noticeItem.classList.add('cart-notice__item--leaving');
    noticeItem.addEventListener(
      'transitionend',
      () => {
        noticeItem.remove();
        if (!noticeState.size) {
          const container = getContainer();
          if (container) container.hidden = true;
        }
      },
      { once: true }
    );
  };

  const rebuildStateFromDom = () => {
    noticeState.clear();
    document.querySelectorAll(SELECTORS.inline).forEach((node) => {
      const message = extractMessage(node);
      if (!message) return;
      const line = node.dataset.line || '';
      const title = getProductTitleFromNode(node);
      const noticeKey = line || `inline-${fallbackIndex++}`;
      noticeState.set(noticeKey, {
        line: noticeKey,
        message: buildMessageWithTitle(message, title),
        productTitle: title,
        showClose: true,
        iconHtml: ''
      });
      hideInlineNotice(line);
    });
  };

  document.addEventListener('cart-notices:capture', (event) => {
    const detail = event.detail || {};
    const line = detail.line ? String(detail.line) : '';
    const rawMessage = (detail.message || '').trim();
    const title = detail.productTitle || getProductTitleFromNode(getInlineNotice(line));
    if (!line) return;
    if (rawMessage) {
      noticeState.set(line, {
        line,
        message: buildMessageWithTitle(rawMessage, title),
        productTitle: title,
        showClose: detail.showClose !== false,
        iconHtml: detail.iconHtml || ''
      });
      hideInlineNotice(line);
    } else {
      noticeState.delete(line);
      clearInlineNotice(line);
    }
    renderNotices();
  });

  document.addEventListener('cart-notices:refresh', () => {
    rebuildStateFromDom();
    renderNotices();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      rebuildStateFromDom();
      renderNotices();
    });
  } else {
    rebuildStateFromDom();
    renderNotices();
  }
})();
